import * as React from 'react';
import * as styles from './styles.css';
import { ActionLink, Body2, UIHeading5 } from '@cian/ui-kit';

export interface IContentFooterProps {
  title: string;
  subtitle: string;
  actionText: string;
  activeNewbuildingId: number;
  chat?: React.ReactNode;
  onCallButtonSlotChange?(newbuildingId: number, slot: HTMLDivElement | null): void;
  onReportError?(newbuildingId: number): void;
}

export const ContentFooter = ({
  title,
  subtitle,
  actionText,
  chat,
  activeNewbuildingId,
  onCallButtonSlotChange,
  onReportError,
}: IContentFooterProps) => {
  const handleCallButtonSlotChange = React.useCallback(
    (slot: HTMLDivElement | null) => onCallButtonSlotChange?.(activeNewbuildingId, slot),
    [activeNewbuildingId, onCallButtonSlotChange],
  );

  return (
    <div className={styles['container']} key={activeNewbuildingId}>
      <div className={styles['text-wrapper']}>
        <UIHeading5 color="text-secondary-default">{title}</UIHeading5>
        <Body2 color="text-secondary-default">
          {subtitle}{' '}
          <ActionLink
            color="current_color"
            fontSize="S"
            inline
            onClick={() => onReportError?.(activeNewbuildingId)}
            textDecoration="underline"
          >
            {actionText}
          </ActionLink>
        </Body2>
      </div>
      <div className={styles['phone-wrapper']}>
        {chat}
        <div ref={handleCallButtonSlotChange} />
      </div>
    </div>
  );
};
